import React from "react";

import { QueryMonitor } from "system/QueryMonitor";
import QueryMonitorRow from "./QueryMonitorRow";
import { Stack } from "@mui/material";

interface QueryMonitorListProps {
  onChange: () => void;
  queryMonitors: Array<QueryMonitor>;
}

export default function QueryMonitorList(props: QueryMonitorListProps): React.JSX.Element {
  const sortedQueryMonitors = props.queryMonitors.sort((a: QueryMonitor, b: QueryMonitor): number => {
    const first = new Date(a.updated_at);
    const second = new Date(b.updated_at);
    return second.getTime() - first.getTime();
  })
  return (
    <Stack spacing={1} sx={{
      marginTop: 1
    }}>
      {sortedQueryMonitors.map((queryMonitor: QueryMonitor) => {
        return <QueryMonitorRow key={queryMonitor.id} onChange={props.onChange} queryMonitor={queryMonitor} />
      })}
    </Stack>
  );
}